import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {DateRange} from 'rsuite/DateRangePicker';
import {t} from '@lingui/core/macro';

import {tariffAPI} from 'entities/tariff';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import RangeInputs from 'shared/ui/Form/RangeInputs/RangeInputs';
import DateRangePickerControlled from 'shared/ui/Date/DateRangePickerControlled/DateRangePickerControlled';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {dateRangeToFilters, getUrlDateRange, toNumberFilter, UrlFiltersData} from 'shared/lib/filterHelper';
import {getActiveOptions} from 'shared/lib/filterOptions';

interface IPromoCodesFiltersForm {
    published?: string,
    tariff?: string,
    activationsFrom?: string,
    activationsTo?: string,
    expireAt?: DateRange,
}

const PromoCodesFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();
    const {data: tariffs} = tariffAPI.useGetTariffsQuery({field: 'price', direction: 'asc'});

    const {register, handleSubmit, control} = useForm<IPromoCodesFiltersForm>({
        defaultValues: {
            published: searchParams.get('published') ?? undefined,
            tariff: searchParams.get('tariff.id') ?? undefined,
            activationsFrom: searchParams.get('activations[gte]') ?? undefined,
            activationsTo: searchParams.get('activations[lte]') ?? undefined,
            expireAt: getUrlDateRange(searchParams, 'expire_at'),
        },
    });

    const tariffOptions = (tariffs ?? []).map(tariff => ({label: tariff.name, value: String(tariff.id)}));

    const toFilters = ({published, tariff, activationsFrom, activationsTo, expireAt}: IPromoCodesFiltersForm) => {
        const data: UrlFiltersData = {
            published: published ?? undefined,
            'tariff.id': tariff ?? undefined,
            'activations[gte]': toNumberFilter(activationsFrom),
            'activations[lte]': toNumberFilter(activationsTo),
        };
        dateRangeToFilters(expireAt, data, 'expire_at');

        return data;
    };

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Статус`}>
                <Select
                    control={control}
                    name="published"
                    data={getActiveOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Тариф`}>
                <Select
                    control={control}
                    name="tariff"
                    data={tariffOptions}
                    cleanable={true}
                    searchable={tariffOptions.length > 5}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Активаций`}>
                <RangeInputs
                    register={register}
                    control={control}
                    fromName="activationsFrom"
                    toName="activationsTo"
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Действует до`}>
                <DateRangePickerControlled control={control} name="expireAt" cleanable={true}/>
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default PromoCodesFiltersForm;
